import ResendEmailConfirmationPage from './ResendEmailConfirmationPage';

export default ResendEmailConfirmationPage;
